// extracted by mini-css-extract-plugin
export var compactFilters = "_fb-4";
export var detailImage = "_fb-1";
export var dropdownContainer = "_fb-2";
export var imageContainer = "_fb-0";
export var selectedCard = "_fb-3";